<i *ngIf="renderSpinner" nz-icon nzType="loading"></i>

<nz-progress
  *ngIf="renderProgress"
  [nzPercent]="uploadingProgress"
  nzType="circle"
  [nzWidth]="50"
></nz-progress>
